<h1 mat-dialog-title>Promote "{{data.label}}"</h1>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <p>This will promote "{{data.label}}" to the sitewide Data View Templates and make it available to all projects.</p>
  <form [formGroup]="form" class="form-full-width" style="margin:20px 10px 10px;">
    <mat-form-field class="form-field label-field">
      <input matInput formControlName="label" name="label" placeholder="Name">
    </mat-form-field>
    <mat-form-field class="form-field description-field">
      <input matInput formControlName="description" name="description" placeholder="Description">
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()" data-id="project-dialog-close">Cancel</button>
  <button mat-flat-button
    color="primary"
    data-id="promote-data-view"
    [disabled]="form.disabled || !form.valid"
    (click)="onPromote()">
    Promote
  </button>
</div>
